import * as React from 'react';
import { IgcRadioComponent as Component } from 'igniteui-webcomponents';
import type { IgcRadioComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * @slot  - The radio label.
 * @slot helper-text - Renders content below the input.
 * @slot value-missing - Renders content when the required validation fails.
 * @slot custom-error - Renders content when setCustomValidity(message) is set.
 * @slot invalid - Renders content when the component is in invalid state (validity.valid = false).
 * @fires igcChange - Emitted when the control's checked state changes.
 * @csspart base - The radio control base wrapper.
 * @csspart control - The radio input control.
 * @csspart label - The radio control label.
 * @class
 */
export const IgrRadio = /* @__PURE__ */ createComponent({
  tagName: 'igc-radio',
  displayName: 'IgrRadio',
  elementClass: Component,
  react: React,
  events: {
    onChange: 'igcChange' as EventName<IgcRadioComponentEventMap['igcChange']>,
  },
});

export type IgrRadio = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrRadioModule = Component;
